export default __webpack_public_path__ + "static/media/UCM logo darkmode.f6e57bee.png";